import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminPriceFiles = lazy(() => import("@/pages/admin/AdminPriceFiles"));

export const Route = createFileRoute("/admin/prisfiler")({
  component: () => <AdminPriceFiles />,
});
